const defaultShape = {
    shape: 'Kołowy'
};

export default defaultShape